import {
  BaseEdge,
  getSmoothStepPath
} from "reactflow";

export default function HiddenComponentEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
}) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    centerY: sourceY + 50,
    targetPosition,
  });
  return (
    <>
      <BaseEdge path={edgePath} markerEnd="default" type="smoothstep" style={style} />
    </>
  );
}
